module.exports = import("https://static.elfsight.com/platform/platform.js");;